const endpoints = {
  otpSend: "admin-utilities/otp/send",
  otpVerify: "admin-utilities/otp/verify",
  adminList: "admins/",
  MDList: "admins/",
  bankList: "banks/",
  regionalOfficeList: "regional-offices",
  masterDistributorsList: "master-distributors/",
  distributorsList: "distributors/",
  subDistributorsList: "sub-distributors/",
  agentsList: "agents/",
  retailerList: "retailers/",
  mnoList: "mnos/",
  manualEntries: "manual-entries/",
  pendingAmount: "pending-amount-transactions/",
  raiseETopUpRequest: "cash-in",
  raiseETopUpRequestPaid: "cash-in/paid",
  repayAdvanceETopUpRequest: "cash-in/repay-advance",
  regionalOffices: "regional-offices",
  target: "mnos/targets/",
  serviceFeeTransaction: "mnos/service-fee/",
  etopUpreceived: "cash-in/received",
  onBoardingRequest: "onboarding-requests/",
  companyList: "companies",
  customerList: "customers/",
  profileTransactions: "transactions/user/self",
  reversalRequest: "transactions/reversal-requests",
  bankAccounts: "balance-sheet/child",
  bankTransactions: "balance-sheet/transactions",
  superAdminTransaction: "transactions/super-admin",
  etopUpReversals: "transactions/reversals",
  mnoTransactions: "transactions/mno-reversals",
  walletTransactions: "balance-sheet/wallet/transactions",
  recoveryPayableTransactions: "balance-sheet/accounts/recovery-payable/transactions",
  customerStockTransactions: "balance-sheet/customer-stock/transactions",
  serviceFeeExpenseTransactions: "balance-sheet/service-fee-expense/transactions",
  equityCapitalTransactions: "balance-sheet/accounts/equity-capital/transactions",
  generalExpenseTransactions: "balance-sheet/accounts/general-expense/transactions",
  cvmCommissionTransactions: "balance-sheet/accounts/cvm-commission/transactions",
  etopupRechargeReports: "reports/etop-up-recharge",
  mnoBundleBalanceActivationReports: "reports/mno-bundle-balance-activation",
  unsuccessfulTransactionReports: "reports/unsuccessful-transactions",
  mnoWiseEtopupAvailableBalanceReports: "reports/mno-available-balance",
  mnoWiseEtopupPurchaseReports: "reports/mno-wise-etop-up-purchases",
  etopupPurchaseOrderReports: "reports/purchased-orders",
  stockAccountStatement: "reports/stock-account",
  moneyAccountStatement: "reports/money-account",
  reportsUsers: "reports/users",
  mnoServiceFeeEarnedReports: "reports/mno-service-fee-report",
  listTickets : "admin-support",
  upfrontSales: "reports/upfront-sales",
  upfrontPurchaseReports: "reports/upfront-purchases",
  childTransaction: 'transactions/child',
  childAdvancePayments: 'transactions/repayments',
  customerMerchantBalance: "reports/customer-merchant-balance",
  reverseFundLogs: "logs/reversal",
  fundTransferLogs: "logs/fund-transfer",
  geographicalSalesReports: "reports/geographical-sales",
  activeChilds: "merchants/children",
  logs: "logs",
  zoodpayMoneyDashboard: "dashboard/money",
  mnoRechargeTrend: "dashboard/mno-recharge-trend",
  etopupStocksTrend: "dashboard/etopup-stocks/trend",
  systemTransactionalPerformance: "dashboard/system-transactional-ratio",
  mnoTargetAchievement: "dashboard/mno-target-achievement",
  onTargetAchievementOfMNO: "reports/on-target-achievement",
  reversalReports: "reports/reversal-report",
  etopupStockReversal: "reports/etop-up-stock-reversal",
  profitabilityReport: "reports/profitability",
  notifications: "notifications/",
  markAllNotificationsRead: "notifications/mark-all-read",
  journalVoucher: "manual-entries/journal-voucher",
  cvmServiceFee: "transactions/cvm-commission"
};
  
  export default endpoints;
  